
export default function routes($stateProvider) {
	$stateProvider
		.state('tutorialPage', {
			url: '/tutorial',
			template: require('./tutorial.html'),
			resolve: {
				tutorial: ['CMS', function (CMS) {
					return CMS.get('tutorial');
				}]
			},
			controller: 'TutorialController',
			controllerAs: 'tutorial'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/tutorial/tutorial.routes.js